module.exports = __webpack_public_path__ + "kudos_5.svg?595fdb5708b4497e53b8135a80826033";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_5.svg
// module id = 150
// module chunks = 0